import createAsyncActions from "../../../utilities/createAsyncActions";
import { GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE } from "../types/getAllScoreCardRiskFactorsByType";

export const {
  getAllScoreCardsRiskFactorsByType,
  getAllScoreCardsRiskFactorsByTypePending,
  getAllScoreCardsRiskFactorsByTypeFulfilled,
  getAllScoreCardsRiskFactorsByTypeRejected,
} = createAsyncActions(
  GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE,
  "getAllScoreCardsRiskFactorsByType"
);



// WEBPACK FOOTER //
// ./src/features/score-card/actions/getAllScoreCardsRiskFactorsByType.js